const FooterData = [
    {
        title: "Useful Links",
        submenu: [
            {
                title: "Schedule",
                link: "/schedule"
            },
            {
                title: "Participants",
                link: "#"
            },
            {
                title: "Terms & Conditions",
                link: "#"
            },
            {
                title: "Privacy Policy",
                link: "#"
            },
        ]
    },
    {
        title: "Socials",
        submenu: [
            {
                title: "Facebook",
                link: "https://www.facebook.com/profile.php?id=61551582736876"
            },
            {
                title: "LinkedIn",
                link: "https://www.linkedin.com/company/innovher-com/"
            },
            {
                title: "X",
                link: "https://twitter.com/innovher"
            },
            {
                title: "Instagram",
                link: "https://www.instagram.com/innovher/"
            },
        ]
    },
    {
        title: "Contact Us",
        submenu: [
            {
                title: "xlr8ar@innovher.com",
                link: "mailto:xlr8ar@innovher.com"
            },
        ]
    }
]

export default FooterData